import * as stateChangeTypes from './stateChangeTypes'

interface OpenModalAction<Data> {
  type: typeof stateChangeTypes.OpenButtonClick
  id?: string | null
  data?: Data
  changes?: ModalState<Data>
}
interface CloseModalAction<Data> {
  type: typeof stateChangeTypes.CloseButtonClick
  changes?: ModalState<Data>
}

export type ModalActionTypes<Data> =
  | OpenModalAction<Data>
  | CloseModalAction<Data>

export interface ModalState<Data> {
  isOpen: boolean
  openedId: string | null | undefined
  _metadata: Data | null | undefined
}

export function modalReducer<Data>(
  state: ModalState<Data>,
  action: ModalActionTypes<Data>
) {
  let changes
  switch (action.type) {
    case stateChangeTypes.CloseButtonClick: {
      // Keep metadata when closing, this is usually used to keep some key information outside the modal
      changes = { isOpen: false, openedId: null }
      break
    }
    case stateChangeTypes.OpenButtonClick: {
      changes = { isOpen: true, openedId: action.id, _metadata: action.data }
      break
    }
    default: {
      throw new Error('Unhandled type')
    }
  }
  return { ...state, ...changes }
}

export default modalReducer
